<template>
  <div class="component_card">
    <div class="column columns redeem_form">
      <div class="column">
        <div class="column tal_c">
          <span class="text_m_blu">
            {{ $t("msg.deposit") }}
          </span>
          <div class="column">

            <button class="btn_redeem bg_colorSubMainLatestGreen" v-if="buttonBlock">
              {{ $t("msg.create_deposit_address") }}
            </button>

            <button class="btn_redeem bg_colorSubMainGreenLT" @click="callFirstStep()" v-else>
              {{ $t("msg.create_deposit_address") }}
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["buttonBlock"],
  created() {
    // this.checkAmount();
  },
  data: () => ({}),
  methods: {
    callFirstStep() {
      this.$emit("callFirstStep");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/deposit_steps/DepoistStepStart.vue